import { ethers } from 'ethers';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/** ユーザーのウォレットデータを取得（Cloud Function経由でdot99のusersコレクションから） */
export async function getUserWalletData(uid) {
  const getUserProfileFn = httpsCallable(functions, 'getUserProfile');
  const { data } = await getUserProfileFn();
  return data;
}

/** 暗号化ウォレットを復号 */
export async function decryptWallet(salt, encryptedWallet) {
  const makePassword = httpsCallable(functions, 'makePassword');
  const { data } = await makePassword({ salt });
  const wallet = await ethers.Wallet.fromEncryptedJson(encryptedWallet, data.password);
  return { address: wallet.address, privateKey: wallet.privateKey };
}
